import {useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import "../Styles/CourseContentPage.css";
//import {Document, Page, PDFViewer, Text, View} from '@react-pdf/renderer';
import "../Styles/Sidebar.css";
import VirtualizedList from "../components/VirtualizedList.jsx";
import ReactPlayer from 'react-player/lazy'
import Exam from "../components/Exam.jsx";
import CustomPdf from "../components/CustomPdf.tsx";
import {Alert} from "@mui/material";

//const YOUTUBE_IFRAME_API = "https://www.youtube.com/iframe_api";

function CourseContentPage() {
    const {courseId} = useParams();
    const [courseContent, setCourseContent] = useState([]);
    const [completedContents, setCompletedContents] = useState([]);
    const [completedContentId, setCompletedContentId] = useState([]);
    const [course, setCourse] = useState([]);
    const [currentContent, setCurrentContent] = useState([]);
    const [currentContentIndex, setCurrentContentIndex] = useState(1);
    const [disableNextButton, setDisableNextButton] = useState(true);
    const [refreshFlag, setRefreshFlag] = useState(false);
    const [examCompleted, setExamCompleted] = useState(true);
    const [exam, setExam] = useState([]);
    const [finalScore, setFinalScore] = useState(0);
    const [participantId, setParticipantId] = useState(null);
    const [examTakeStatus, setExamTakeStatus] = useState(false);


    useEffect(() => {
        const setExamStatus = async () => {
            const examTakeStatus = completedContents.some(
                (content) => content.type === "exam"
            );
            setExamTakeStatus(examTakeStatus);


        }
        setExamStatus().then(r => console.log("exam status set"));
    }, [completedContents]);


    useEffect(() => {
        const fetchParticipantId = async () => {
            const email = localStorage.getItem("userEmail");
            if (!email) {
                alert("Kullanıcı emaili bulunamadı.");
                return;
            }

            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/course-participants/getByUserEmailAndCourse`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        email: email,
                        courseId: courseId
                    })
                });

                if (response.ok) {
                    const data = await response.json();
                    setParticipantId(data.id);
                    console.log("participant id" + participantId);
                } else {
                    console.error("Participant ID alınamadı");
                }
            } catch (error) {
                console.error("Hata:", error);
            }
        };

        fetchParticipantId().then(r => console.log(participantId));
    }, [courseId]);

    const handleQuizFinish = (score, examId) => {
        setExamCompleted(true);
        setFinalScore(score);
        submitExamResult(score, examId).then(r => console.log("Exam result submitted"));
        handleProgress().then(r => console.log("Progress handled for exam"));
    };

    const submitExamResult = async (score, examId) => {
        try {
            const payload = {
                exam_id: examId,
                participant_id: participantId,
                score: score,
                completed_at: new Date().toISOString(),
            };

            const result = await fetch(`${process.env.REACT_APP_API_URL}/exam-results/save`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            });

            if (!result.ok) throw new Error('Sunucu hatası');

        } catch (err) {
            console.error(err);
            alert('Sonuç gönderilemedi. Lütfen tekrar deneyin.');
        }
    };


    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_URL}/courseContents/getByCourseId/` + courseId)
            .then((response) => response.json())
            .then((data) => {
                setCourseContent(data);
            })
            .catch((error) => {

                console.error("Error fetching course contents:", error);
            });
    }, []);

    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_URL}/courses/getbyid/` + courseId)
            .then((response) => response.json())
            .then((data) => {
                setCourse(data);
            })
            .catch((error) => {
                console.error("Error fetching course contents:", error);
            });
    }, []);

    useEffect(() => {
        fetchCompletedContents().then(r => console.log("Completed contents fetched"));
        fetchExam().then(r => {
            console.log("Exam fetched");


        });
    }, [participantId]);


    const fetchCompletedContents = async () => {
        try {
            const response = await
                fetch(`${process.env.REACT_APP_API_URL}/course-progress/completed`,
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                            participantId: participantId,
                            courseId: courseId
                        }
                    )
                }
            );
            if (response.ok) {
                const data = await response.json();
                setCompletedContents(data);
                setCompletedContentId(data.map(content => content.id));
                setRefreshFlag(prev => !prev); // Listeyi yenile
            } else {
                console.error("Failed to fetch completed contents");
            }
        } catch (error) {
            console.error("Error fetching completed contents:", error);
        }
    };


    const fetchExam = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/exams/getByCourse/` + courseId, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            if (!response.ok) {
                throw new Error(`Failed to fetch data. Status: ${response.status}`);
            }

            const data = await response.json();
            if (data.length > 0) {
                setExam(data[0]);
                console.log("Exam data:", data[0]);
            }
            return data;

        } catch (error) {
            console.error("Error fetching question groups:", error.message);
        }
    };


    if (!course) {
        return <h2 style={{color: "red"}}>Böyle bir kurs bulunamadı! courseId: {courseId}</h2>;
    }

    const handleNext = async () => {
        if (currentContentIndex <= courseContent.length - 1) {
            console.log("Current content index:", currentContentIndex);

            const nextIndex = currentContentIndex + 1;
            const nextContent = courseContent.find(content => content.position === nextIndex);
            console.log("Next content:", nextContent);
            console.log("Next index:", nextIndex);

            if (nextContent) {
                if (!await isContentCompleted(currentContent)) {
                    //make post request to update course progress
                    handleProgress().then(r => console.log("progress handled"));
                }
                if (!await isContentCompleted(nextContent)) {
                    // disable next button
                    setDisableNextButton(true);
                }
                handleContentChange(nextContent).then(r => console.log("handle content change "));
                setCurrentContentIndex(nextIndex);

            } else {
                console.warn("Bir sonraki içerik bulunamadı.");
            }
        }
    }

    const handleVideoEnd = async () => {
        if (currentContentIndex < courseContent.length - 1) {

            // activate next button
            setDisableNextButton(false);
        }

        if (!await isContentCompleted(currentContent)) {
            //make post request to update course progress
            await handleProgress();
        }
        console.log("Video ended");
    };

    const isContentCompleted = async (content) => {
        try {
            const response = await fetch(
                `${process.env.REACT_APP_API_URL}/course-progress/content-completed`,
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                            participantId: participantId,
                            courseId: courseId,
                            courseContentId: content.id
                        }
                    )

                }
            );
            if (response.ok) {
                const data = await response.json();
                return !!data;
            } else {
                console.error("Failed to fetch completed contents");
                return false;
            }
        } catch (error) {
            console.error("Error fetching completed contents:", error);
            return false;
        }
    }

    const handleProgress = async () => {
        try {
            const response = await fetch(
                `${process.env.REACT_APP_API_URL}/course-progress/update?participantId=${participantId}&courseContentId=${currentContent.id}&courseId=${courseId}`,
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }
            );

            if (response.ok) {
                alert('İçerik tamamlandı!');
                await fetchCompletedContents();


            } else {
                alert('Tamamlama işlemi başarısız oldu!');
            }
        } catch (error) {
            console.error('Error:', error);
            alert('Bir hata oluştu.');
        }
    }
    const handleItemClick = async (content) => {
        console.log("Clicked content:", content);
        await handleContentChange(content);

    };

    const handleContentChange = async (content) => {
        try {
            const response = await fetch(
                `${process.env.REACT_APP_API_URL}/course-progress/can-access?participantId=${participantId}&courseContentId=${content.id}&courseId=${courseId}`
            );
            if (response.ok) {
                const canAccess = await response.json();

                console.log("Can access content:", canAccess);
                console.log("Content:", content);
                if (canAccess) {
                    setCurrentContent(content);
                    // if current content position + 1 is in completed contents, enable next button
                    const nextContent = courseContent.find(c => c.position === content.position + 1);
                    if (nextContent && completedContentId.includes(nextContent.id)) {
                        setDisableNextButton(false);
                    }
                    // if current content type is document enable next button
                    if (content.type === "document") {
                        setDisableNextButton(false);

                    }

                    setCurrentContentIndex(content.position);
                } else {
                    alert("Videoyu tamamlamadan ilerleyemezsiniz!"); // access deny
                }
            } else {
                console.error("Error checking content access");
                alert("Bağlantıda bir sorun oluştu. Lütfen tekrar deneyin.");
            }
        } catch (error) {
            console.error("Error checking content access:", error);
            alert("Bir hata oluştu. Lütfen tekrar deneyin.");
        }
    };


    return (
        <div className="course-content-container">
            {/* Sidebar */}
            <div className="sidebar" style={{backgroundColor: "rgb(177,177,181)"}}>
                <h3>{course.name}</h3>

                <VirtualizedList items={courseContent} completedContents={completedContentId}
                                 onItemClick={handleItemClick} extraData={refreshFlag}
                                 currentContentIndex={currentContentIndex}/>

            </div>

            {/* Content */}
            <div className="content">
                {currentContent.type === "video" ? (
                    <div>
                    <div className="video-container" style={{
                        width: '100%',
                        maxWidth: '-webkit-fill-available',
                        height: '70%',
                        maxHeight: '-webkit-fill-available',
                        padding: '5%'
                    }}>
                        <ReactPlayer url={currentContent.url} controls={false} onEnded={handleVideoEnd}
                                     style={
                                         {
                                             marginTop: "20px",
                                             margin: "auto",
                                             width: "100%",
                                             height: "100%",
                                         }
                                     }/>


                    </div>
                    <Alert variant="outlined" severity="info" style={{width:'70%', marginLeft:'17%'}}>Videoya çift tıklayarak tam ekran görüntüleyebilirsiniz.</Alert>
                        <Alert variant="outlined" severity="info" style={{width:'70%', marginLeft:'17%'}}>Fareyi video üzerinde sağa sola hareket ettirerek 3 boyutlu izleme deneyimi yaşayabilirsiniz.</Alert>
                    </div>
                ) : currentContent.type === "document" ? (

                    <div className="document-container" style={{
                        width: '100%',
                        maxWidth: '-webkit-fill-available',
                        height: '100%',
                        maxHeight: '-webkit-fill-available'
                    }}>
                        {/*
                        <img style={
                            {
                                position: 'absolute',
                                alignSelf: 'anchor-center',
                                width: '40%', // Boyut
                                opacity: 0.2, // Yarı saydamlık
                                transform: 'rotate(-30deg)',
                                zIndex: 999,

                            }
                        } src='/images/logo.svg' alt={
                            "Filigran"
                        }/>


                        <PDFViewer style={{
                            width: '100%',
                            maxWidth: '-webkit-fill-available',
                            height: '100%',
                            maxHeight: '-webkit-fill-available'
                        }}>
                            <Document>
                                <Page size="A4">
                                    <View>
                                        <Text>{currentContent.text}</Text>
                                    </View>
                                </Page>
                            </Document>
                        </PDFViewer>*/}

                        {/*TODO: Custom PDF Usage With All Features*/}
                        <CustomPdf src={currentContent.url} showDownload={false} showPrint={false} renderTextLayer={false}/>

                    </div>
                ) : currentContent.type === "exam" && exam ? (
                    <div>
                        {examTakeStatus ? (
                            <h2>Sınav daha önce çözülmüş</h2>
                        ) : (
                        <Exam
                            onFinish={handleQuizFinish}
                            exam={exam}
                            participantId={participantId}
                        />
                        )}

                    </div>

                ) : (
                    <div>
                        <h3 align='center'> {course.name}</h3>
                        <p align='center'>
                            {course.description}
                        </p>
                        <p align='center'>
                            Başlamak için bir ders seç
                        </p>
                    </div>

                )}

                <button className="next-button" onClick={handleNext} disabled={disableNextButton}>Sonraki</button>


            </div>
        </div>
    )
        ;
}

export default CourseContentPage;
